
<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_16571_26316)">
    <rect x="8.96582" y="21.5" width="12.25" height="5.5" rx="2.75" :stroke="color" stroke-width="2" />
    <circle cx="14.7158" cy="8.5" r="3.5" :stroke="color" stroke-width="2" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6707 20.089C17.9261 18.9815 16.1266 17.669 15.0922 16.538C14.0578 15.4071 12.581 14.1578 11.5954 13.1431C10.6097 12.1283 9.01247 11.6869 7.96721 12.0621C6.92195 12.4372 3.26598 14.1322 2.23683 14.7131C1.20769 15.294 0.951792 16.6129 1.20769 18.2733C1.46359 19.9337 3.34279 21.8892 3.34279 21.8892C3.34279 21.8892 0.573106 23.7637 0.231829 24.0829C-0.109447 24.402 -0.109447 25.6278 0.47243 26.2877C1.05431 26.9475 1.98003 27.3477 2.71721 26.9013C3.45439 26.4549 7.58287 23.6359 7.58287 23.6359C7.58287 23.6359 8.15323 22.5351 7.96721 21.8892C7.78119 21.2433 6.67971 20.5001 6.67971 20.5001L12.0215 17.9016L14.3459 20.089C14.3459 20.089 15.4153 21.1965 16.6707 20.089Z"
      :stroke="color"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_16571_26316">
      <rect width="32" height="32" fill="white" />
    </clipPath>
  </defs>
</svg>
